import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['input', 'preview', 'removeFlag'];

  #objectUrl = null;

  disconnect() {
    this.#revoke();
  }

  select() {
    const file = this.inputTarget.files[0];
    if (!file) {
      return;
    }

    this.#revoke();
    this.#objectUrl = URL.createObjectURL(file);
    this.previewTarget.src = this.#objectUrl;
    this.element.classList.remove('is-empty', 'is-stored');
    this.#flagRemoval(false);
  }

  remove() {
    this.#revoke();
    this.inputTarget.value = '';
    this.previewTarget.removeAttribute('src');
    this.element.classList.remove('is-stored');
    this.element.classList.add('is-empty');
    this.#flagRemoval(true);
  }

  #flagRemoval(removed) {
    if (this.hasRemoveFlagTarget) {
      this.removeFlagTarget.value = String(removed);
    }
  }

  #revoke() {
    if (this.#objectUrl) {
      URL.revokeObjectURL(this.#objectUrl);
      this.#objectUrl = null;
    }
  }
}
